import { useState } from "react";
import "./css/adminpushmadetemplate.css";
import { apiPost } from "../../../utils/apiClient";

const AdminPushMadeTemplate = ({ onClose, activeType, activeTarget, onSuccess }) => {
  const [selectedHour, setSelectedHour] = useState("");
  const [selectedMinute, setSelectedMinute] = useState("");
  const [recipient, setRecipient] = useState(activeTarget === "store" ? "가맹점" : "사용자");
  const [titleValue, setTitleValue] = useState("");
  const [contentValue, setContentValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const MAX_LEN = 50;

  const handleSubmit = async () => {
    setErrorMsg("");

    if (!titleValue.trim()) return setErrorMsg("제목을 입력해 주세요.");
    if (!contentValue.trim()) return setErrorMsg("내용을 입력해 주세요.");
    if (activeType === "auto" && (!selectedHour || !selectedMinute))
      return setErrorMsg("발송 시간을 선택해 주세요.");

    const payload = {
      title: titleValue.trim(),
      content: contentValue.trim(),
      receiverType: recipient,
      isAuto: activeType === "auto",
      sendDateTime:
        activeType === "auto"
          ? `${selectedHour}:${selectedMinute}:00`
          : null,
    };

    setIsSubmitting(true);
    const response = await apiPost("/admin/pushTemplate", payload);
    setIsSubmitting(false);

    if (response.ok) {
      onSuccess?.();
      onClose();
    } else {
      setErrorMsg("템플릿 등록에 실패했습니다.");
    }
  };

  return (
    <div className="adminpushmadetemplate-backdrop">
      <div className="adminpushmadetemplate-modal">
        <div className="adminpushmadetemplate-header">
          <div className="adminpushmadetemplate-header-title">템플릿 등록</div>
          {activeType === "direct" ? (
            <div className="adminpushmadetemplate-header-subtitle">
              즉시 발송 템플릿을 등록합니다
            </div>
          ) : (
            <div className="adminpushmadetemplate-header-subtitle">
              시스템 발송(자동) 템플릿을 등록합니다
            </div>
          )}
        </div>

        <div className="adminpushmadetemplate-section">
          <div className="adminpushmadetemplate-row">
            <div className="adminpushmadetemplate-target">
              <div className="adminpushmadetemplate-label">수신 대상</div>
              <select
                className="adminpushmadetemplate-select"
                value={recipient}
                onChange={(e) => setRecipient(e.target.value)}
              >
                <option value="가맹점">가맹점</option>
                <option value="사용자">사용자</option>
              </select>
            </div>

            <div
              className="adminpushmadetemplate-time"
              style={{ visibility: activeType === "auto" ? "visible" : "hidden" }}
            >
              <div className="adminpushmadetemplate-label">발송 시간</div>
              <div className="adminpushmadetemplate-time-selects">
                <select
                  className="adminpushmadetemplate-time-select"
                  value={selectedHour}
                  onChange={(e) => setSelectedHour(e.target.value)}
                >
                  <option value="">--</option>
                  {Array.from({ length: 24 }, (_, i) =>
                    String(i).padStart(2, "0")
                  ).map((h) => (
                    <option key={h} value={h}>{h}</option>
                  ))}
                </select>
                <span className="adminpushmadetemplate-time-unit">시</span>
                <select
                  className="adminpushmadetemplate-time-select"
                  value={selectedMinute}
                  onChange={(e) => setSelectedMinute(e.target.value)}
                >
                  <option value="">--</option>
                  {["00", "10", "20", "30", "40", "50"].map((m) => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
                <span className="adminpushmadetemplate-time-unit">분</span>
              </div>
            </div>
          </div>

          <div className="adminpushmadetemplate-title">
            <div className="adminpushmadetemplate-label">제목</div>
            <input
              type="text"
              className="adminpushmadetemplate-input"
              placeholder="제목을 입력하세요"
              maxLength={MAX_LEN}
              value={titleValue}
              onChange={(e) => { if (e.target.value.length <= MAX_LEN) setTitleValue(e.target.value); }}
            />
            <div className="adminpushmadetemplate-char-count">
              {titleValue.length}/50
            </div>
          </div>

          <div className="adminpushmadetemplate-content">
            <div className="adminpushmadetemplate-label">내용</div>
            <textarea
              className="adminpushmadetemplate-textarea"
              placeholder="내용을 입력하세요"
              rows="6"
              maxLength={MAX_LEN}
              value={contentValue}
              onChange={(e) => { if (e.target.value.length <= MAX_LEN) setContentValue(e.target.value); }}
            ></textarea>
            <div className="adminpushmadetemplate-char-count">
              {contentValue.length}/50
            </div>
          </div>
        </div>

        <div className="adminpushmadetemplate-footer">
          {errorMsg && (
            <div className="adminpushmadetemplate-error">{errorMsg}</div>
          )}
          <div className="adminpushmadetemplate-footer-btns">
            <button
              className="adminpushmadetemplate-btn-submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "등록 중..." : "등록"}
            </button>
            <button
              className="adminpushmadetemplate-btn-cancel"
              onClick={onClose}
              disabled={isSubmitting}
            >
              취소
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPushMadeTemplate;
